export default __webpack_public_path__ + "static/media/monitor.f787aa20.svg";